import React from 'react'
import { Breadcrumb, FindAgent, MainHeading, NoticeLinks, WebAccessibilityContent } from '../../components'
import { Col, Container, Row } from 'react-bootstrap'

const WebAccessibility = () => {
    const crumbsdata= [
        {label:'Sentry Insurance home',link:'/'},
        {label:'Web accessibility',link:'/footer/web-accessibilitys'}
    ]
    return (
        <div className='webaccessbility-wrapped'>
            <Container>
                <Breadcrumb crumbs={crumbsdata}/>
                <MainHeading title="Policy regarding web accessibility" showshare={false} />
                <div className='content-pages-wrapper'>
                    <Row>
                        <Col md={8} sm={12}  className='order-md-1 order-2'>
                            <WebAccessibilityContent />
                        </Col>
                        <Col md={4} sm={12}  className='order-md-2 order-1'>
                            <NoticeLinks />
                        </Col>
                    </Row>
                </div>
                <FindAgent />
            </Container>
        </div>
    )
}

export default WebAccessibility;
